import Task from '../task';

/**
 * Create the action
 */

const { thunk, request, success, error } = Task.update((data, fetch) => {
    data = {
        ...data,
        _method: 'PUT'
    };
    return fetch.post(`/task/${data.id}`, data);
}, {
    onError: function(error, dispatch) {

        const errors = Object.keys(error.response.data.errors);

        alert('Something went wrong');

    }
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
